module.exports = __webpack_public_path__ + "static/img/5.5f15678.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/eng/5.png
// module id = hti+
// module chunks = 0